import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { CallWithAuth } from '../../actions/apiAction';
import { FEEDBACK_URL } from '../../utils/apiUrl';
import './FeedbackForm.scss';

const FEEDBACK_TYPES = ['Text quality', 'Call quality', 'Video quality', 'Connection issues', 'Other'];

const FeedbackForm = ({ onClose }) => {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [type, setType] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await CallWithAuth('POST', FEEDBACK_URL, { rating: rating || null, category: type || null, comments: message || null });
            if (response.status === 201) setSubmitted(true);
            else toast.error('Failed to send feedback');
        } catch { toast.error('Failed to send feedback'); }
        finally { setLoading(false); }
    };

    if (submitted) return (
        <div className="feedback-form feedback-success">
            <div className="feedback-success-icon">✓</div>
            <p className="feedback-heading">Thanks for your feedback!</p>
            <p className="feedback-copy">We'll get right on this.</p>
            {onClose && <button onClick={onClose} className="feedback-submit feedback-done">Done</button>}
        </div>
    );

    return (
        <div className="feedback-form">
            {onClose && <button className="feedback-close" aria-label="Close feedback form" onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
            </button>}
            <h1 className="feedback-heading">Help us improve</h1>
            <p className="feedback-copy">Your feedback helps us build a better experience for everyone.</p>

            <p className="feedback-label">Rate your recent experience</p>
            <div className="feedback-stars">
                {[1, 2, 3, 4, 5].map(i => <button key={i} type="button" aria-label={`${i} star${i > 1 ? 's' : ''}`} className={i <= (hoverRating || rating) ? 'active' : ''} onClick={() => setRating(i)} onMouseEnter={() => setHoverRating(i)} onMouseLeave={() => setHoverRating(0)}>★</button>)}
            </div>

            <p className="feedback-label">What can we do better?</p>
            <div className="feedback-chips">
                {FEEDBACK_TYPES.map(t => <button key={t} type="button" onClick={() => setType(t)} className={type === t ? 'active' : ''}>{t}</button>)}
            </div>

            <p className="feedback-label">Any additional thoughts?</p>
            <textarea rows={5} placeholder="Tell us more about your experience..." className="feedback-textarea" value={message} onChange={e => setMessage(e.target.value)} />
            <button onClick={handleSubmit} disabled={loading} className="feedback-submit">{loading ? 'Submitting...' : 'Send Feedback'}</button>
        </div>
    );
};

export default FeedbackForm;
